

























































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/customer-header.vue";
@Component({
  components: {
    MainHeader,
  },
})
export default class Name extends Vue {
  private list: any = [
    "西藏自治区藏医院",
    "内蒙古自治区国际蒙医医院",
    "新疆维吾尔自治区维吾尔医医院",
    "首都医科大学宣武医院",
    "北京中医药大学东直门医院",
    "首都医科大学附属北京中医医院",
    "中国藏学研究中心北京藏医院",
    "北京小汤山医院",
    "中国民族医药学会",
  ];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get system() {
    return this.$store.state.system;
  }
  private goRoute(path: any) {
    this.$router.push(path);
  }
  private beforeCreate() {
    // if (this.$store.state.systemInfo.GLOBAL_SYSTEM == "管理端") {
    //   this.$store.commit("updateSystem", "管理端");
    //   // 重定向到登录页
    //   this.$router.replace("/access/login");
    // } else {
    //   this.$store.commit("updateSystem", "用户端");
    // }
  }
  private mounted() {
    if (!this.$store.state.system) {
      this.$store.commit("updateSystem", "用户端");
    }
  }
}
